import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout/Default";
import Footer from "../../components/Partials/Footer";
import Header from "../../components/Partials/Header";
import { getItemMenu, getMapCoordinates } from "../../assets/js/api";
import { useLocation } from "react-router-dom";
import { leafletIcon, translate, getCurrentLanguage } from '../../assets/js/functions';

export default function Mapa({ section_id }) {
    const location = useLocation();
    const [item, setItem] = useState(location.state?.item || null);
    const [data, setData] = useState(null);
    const [isBirthplace, setIsBirthplace] = useState(true);
    const [map, setMap] = useState(null);
    const [markers, setMarkers] = useState([]);
    const zoom = 8;
    const target = [42.6954, -1.6761];

    useEffect(() => {
        getMapCoordinates(isBirthplace).then((coordinates) => {
            setData(coordinates);
        });
    }, [isBirthplace]);

    useEffect(() => {
        if (section_id && !item) {
            getItemMenu(section_id).then((foundItem) => {
                setItem(foundItem);
            });
        }
    }, [section_id, item]);


    useEffect(() => {
        const loadLeaflet = async () => {
            if (!window.L) {
                // Load Leaflet CSS
                const leafletCSS = document.createElement("link");
                leafletCSS.rel = "stylesheet";
                leafletCSS.href = "https://unpkg.com/leaflet@1.6.0/dist/leaflet.css";
                document.head.appendChild(leafletCSS);

                // Load Leaflet JS
                const leafletJS = document.createElement("script");
                leafletJS.src = "https://unpkg.com/leaflet@1.6.0/dist/leaflet.js";
                leafletJS.async = true;
                document.body.appendChild(leafletJS);

                await new Promise((resolve) => {
                    leafletJS.onload = resolve;
                });
            }
            if (data) initMap();
        };

        if (data) {
            loadLeaflet();
        }
    }, [data]);

    function initMap() {
        const L = window.L;
        const mapDiv = document.getElementById("map");

        if (mapDiv && !map) {
            const mapInstance = L.map(mapDiv).setView(target, zoom);
            L.tileLayer('https://{s}.tile.osm.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            }).addTo(mapInstance);
            setMap(mapInstance);


            updateMarkers(mapInstance);
        }
    }


    function updateMarkers(mapInstance) {
        const L = window.L;


        markers.forEach(marker => {
            mapInstance.removeLayer(marker);
        });
        setMarkers([]);


        const newMarkers = data.map(item => {
            if (item.coordinates && item.coordinates.length >= 2) {
                const [longitude, latitude] = item.coordinates;
                const iconColor = isBirthplace ? "#000000" : "#795d04";
                const icon = leafletIcon(iconColor);

                const marker = L.marker([latitude, longitude], { icon }).addTo(mapInstance);
                const maestroNames = item.maestros
                    .map(maestro =>
                        `<li><a href="/maestros/` + getCurrentLanguage() + `/mapa/ficha/${maestro.section_id}" class="popup-name">
                        ${maestro.ref_victim_name} ${maestro.ref_victim_surname}
                    </a></li>`
                    )
                .join('');

                marker.bindPopup(`<div class="popup-content"><ul>${maestroNames}</ul></div>`);
                return marker;
            }
            return null;
        }).filter(marker => marker !== null);

        setMarkers(newMarkers);
    }

    useEffect(() => {
        if (map && data) {
            updateMarkers(map);
        }
    }, [data, isBirthplace]);

    const handleFilterChange = (isBirthplaceSelected) => {
        setIsBirthplace(isBirthplaceSelected);
    };

    return (
        <Layout pageMeta={{}}>
            <div className="page-container py-5 is-flex is-flex-direction-column">
                <Header></Header>
                <main id="main" className="is-relative mb-7">
                    <div className="wrapper flow--l">
                        <h1 className="has-text-centered">{item ? item.term : ""}</h1>
                        <p className="has-text-centered">{item ? item.abstract : ""}</p>
                    </div>
                    <div className="wrapper mt-6">
                        <div className="map-buttons is-flex is-flex-wrap-wrap gap-3">
                            <button
                                type="button"
                                className={isBirthplace ? "active" : ""}
                                onClick={() => handleFilterChange(true)}
                            >
                                {translate('Lugar de nacimiento')}
                            </button>
                            <button
                                type="button"
                                className={!isBirthplace ? "active" : ""}
                                onClick={() => handleFilterChange(false)}
                            >
                                {translate('Plaza escolar')}
                            </button>
                        </div>
                    </div>
                    <div id="map" className="mapa-maestros mt-4"></div>
                </main>
                <Footer></Footer>
            </div>
        </Layout>
    );
}
